import { styled } from "styled-components";
const FrameImpl = styled("div")(
  ({ theme }) => ({
    border: `0 solid ${theme.borderColor}`,
    borderRadius: "inherit",
    position: "relative",
    overflow: "auto"
  }),
  ({ $borderBottom }) => ({
    borderBottomWidth: $borderBottom ? 1 : 0
  }),
  ({ $borderLeft }) => ({
    borderLeftWidth: $borderLeft ? 1 : 0
  }),
  ({ $borderRight }) => ({
    borderRightWidth: $borderRight ? 1 : 0
  }),
  ({ $borderTop }) => ({
    borderTopWidth: $borderTop ? 1 : 0
  }),
  ({ $sizing }) => $sizing === "fit-content" ? {
    flex: "0 0 auto"
  } : {
    flex: "1 1 0"
  }
);
export {
  FrameImpl
};
